var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.882,
    height: 26.737,
    viewBox: "0 0 20.882 26.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6913",
    "data-name": "Path 6913",
    d: "M195.807,10.23a28.51,28.51,0,0,1-.758,3.415,8.391,8.391,0,0,1-5.369,5.592,5.544,5.544,0,0,1-5.229-.545,3.73,3.73,0,0,1-.475-.414c-.132-.133-.244-.286-.417-.494-.326,1.244-.641,2.421-.942,3.6a10.909,10.909,0,0,1-2.512,4.847,6.029,6.029,0,0,0-.38.5l-.18-.077c-.063-.54-.113-1.082-.192-1.62a16.719,16.719,0,0,1,.671-6.65c.46-1.8.873-3.6,1.285-5.412a1.355,1.355,0,0,0-.079-.657,5.95,5.95,0,0,1,.021-3.97,2.827,2.827,0,0,1,2.546-2.03,1.87,1.87,0,0,1,2.066,2.008,17.927,17.927,0,0,1-.566,3.08c-.183.8-.437,1.584-.681,2.369-.6,1.916.839,3.571,3.068,3.154a4.606,4.606,0,0,0,3.234-2.48,9.152,9.152,0,0,0,.948-6.863,5.967,5.967,0,0,0-4.907-4.58,7.607,7.607,0,0,0-6.34,1.322,6.872,6.872,0,0,0-1.555,9.265c.069.1.188.226.169.316-.16.751-.334,1.5-.546,2.237a.79.79,0,0,1-.539,0,4.325,4.325,0,0,1-1.8-1.648,8.194,8.194,0,0,1-1.327-3.559,1.633,1.633,0,0,0-.093-.292V8.964c.041-.256.075-.514.125-.768A9.325,9.325,0,0,1,181.617.644,26.781,26.781,0,0,1,184.628,0h2c.43.071.865.122,1.291.215a9.384,9.384,0,0,1,7.284,6,19.066,19.066,0,0,1,.6,2.536Z",
    transform: "translate(-174.925)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.7bc0c6efb8fd277e5efec6ab1c302bff.svg";
export { ForwardRef as ReactComponent };